<!--
 * @Author: your name
 * @Date: 2021-11-11 12:50:34
 * @LastEditTime: 2022-06-21 11:04:29
 * @LastEditors: liuwujiang@easyretailpro.com liuwujiang@easyretailpro.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \tongxing\src\views\home.vue
-->
<template>
    <div class="container page">
        <mini-navbar-sub :title="title"></mini-navbar-sub>
        <!-- <van-notice-bar speed="26">
            <div slot="default">
                <div class="avatar-bar flex-mode">
                    <img class="avatar" src="https://img.js.design/assets/smartFill/img334164da748e08.jpg" alt="" v-for="(item, index) in 10" :key="index">
                </div>
            </div>
        </van-notice-bar> -->
        <div class="" v-if="type == 1">
            <!-- <div class="ppt-row"> -->
                <preview-pdf :url="fileList2[0].url"></preview-pdf>
                <!-- <img class="ppt-row__img" src="https://img.js.design/assets/img/624c32710726a86035828c0e.jpg" alt="">
                <img class="ppt-row__img" src="https://img.js.design/assets/img/624c3286f6087e4a368d0d5d.jpg" alt="">
                <img class="ppt-row__img" src="https://img.js.design/assets/img/624c329086dcd873bfbf4708.jpg" alt=""> -->
            <!-- </div> -->
        </div>
        <div v-if="type == 2" style="padding: 8px;">
            <van-image class="preview-img" lazy-load :src="fileList2[0].url"></van-image>
            <!-- <div class="preview-img">
                <img v-lazy="fileList2[0].url" class="preview-img" />
            </div> -->
        </div>
        <div class="content" v-else-if="type == 3">
            <div class="video-block">
                <div class="video-block__header">
                    {{info.studyName}}
                </div>
                <div class="video-block__body">
                    <preview-video v-if="fileList2 && fileList2.length > 0" :url="fileList2[0].url" width="340px"></preview-video>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import PreviewVideo from '@/components-busi/preview-video5/index.vue'
import PreviewPdf from '@/components-busi/preview-pdf5/index.vue'
export default {
    data() {
        return {
            baseFileUrl: '',
            id: '',
            title: '',
            type: 1, // 1: pdf, 2: png, 3: mp4
            info: {},
            fileList2: [], // 课程附件,
            openInIOS: this.$store.state.app.system.openInIOS
        }
    },
    components: {
        PreviewVideo,
        PreviewPdf,
    },
    created() {
        this.baseFileUrl = this.$config.baseFileUrl
        var routeParams = this.$route.query
        console.log(routeParams)
        if(routeParams) {
            this.id = routeParams.id
            this.title = routeParams.catalogue
            this.type = routeParams.type
            this.getInfo()
        }
    },
    computed: {
    },
    mounted() {
        this.timer = setInterval(this.startStudy, 15000); // 10s一次记录用户学习情况
    },
    methods: {
        async startStudy() {
            console.log("学习记录")
            let params = { courseId: this.id, studySeconds: 15 }
            await this.$api.studyCourseClient.saveStudyCount(params)
        },
        getInfo() {
            this.$api.studyCourseClient.getStudyCourseById(this.id).then(res=> {
                if(res) {
                    this.info = res
                    var fileList2 = []
                    this.getFile(res.fileId, fileList2)
                    this.fileList2 = fileList2
                }
            })
        },
        getFile(fileId, fileList = []) {
            if(!fileId) return
            this.$api.uploadFileClient.getAttachmentById(fileId).then(res=> {
                if(res) {
                    let path = res.filePath
                    let fileName = res.realName
                    let url = this.openInIOS?this.$config.baseFileUrlIOS + path: this.$config.baseFileUrl + path
                    if(this.type == 2) {
                        url = this.$config.baseFileUrl + path
                    }
                    let fileOptions = { url: url, name: fileName, id: fileId, path: path }
                    fileList.push(fileOptions)
                }
            })
        },
        // getFileByIOS() {
        //     if(!fileId) return
        //     this.$api.uploadFileClient.getAttachmentById(fileId).then(res=> {
        //         if(res) {
        //             let path = res.filePath
        //             let fileName = res.realName
        //             let fileOptions = { url: this.openInIOS?this.$config.baseFileUrlIOS + path: this.$config.baseFileUrl + path, name: fileName, id: fileId, path: path }
        //             fileList.push(fileOptions)
        //         }
        //     })
        // },
    },
    beforeDestroy() {
        console.log("结束学习")
        if(!this.timer) return
        clearInterval(this.timer);
    },  
}
</script>
<style lang="less" scoped>
    @import './index.less';
</style>